<template>
  <div class="culture-center">
    <!-- 左侧面板 -->
    <div class="culture-left-panel-wrapper">
      <div class="culture-left-panel">
      <!-- 发布活动统计 -->
      <div class="card section-activity-stats">
        <div class="section-header">
          <div class="section-title">发布活动统计</div>
          <button class="btn btn-sm" @click="showDetails">详情</button>
        </div>
        <div class="activity-stats-content">
          <div class="stats-chart">
            <div ref="activityStatusChartRef" class="chart-container"></div>
          </div>
          <div class="stats-metrics">
            <div class="metric-item">
              <div class="metric-value">532</div>
              <div class="metric-label">总报名人数</div>
            </div>
            <div class="metric-item">
              <div class="metric-value">175</div>
              <div class="metric-label">场均报名</div>
            </div>
            <div class="metric-item">
              <div class="metric-value">200</div>
              <div class="metric-label">报名到场率</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 社区活动列表 -->
      <div class="card section-activity-list">
        <div class="section-header">
          <div class="section-title">社区活动列表</div>
          <button class="btn btn-sm" @click="showDetails">详情</button>
        </div>
        <div class="activity-list-scroll">
          <div
            v-for="activity in displayedActivities"
            :key="activity.id"
            class="activity-list-item"
            :class="{ active: selectedActivity && selectedActivity.id === activity.id }"
            @click="selectActivity(activity)"
          >
            <div class="activity-thumbnail">
              <img v-if="activity.thumbnail" :src="activity.thumbnail" :alt="activity.title" />
              <div v-else class="thumbnail-placeholder">🏓</div>
            </div>
            <div class="activity-info">
              <div class="activity-title">{{ activity.title }}</div>
              <div class="activity-meta">
                <span class="activity-location">{{ activity.location }}</span>
                <span class="activity-date">{{ activity.dateRange }}</span>
              </div>
            </div>
            <div class="activity-status" :class="activity.statusClass">
              {{ activity.status }}
            </div>
          </div>
        </div>
        <div class="activity-pagination">
          <span class="page-info">总共{{ totalActivities }}个活动</span>
          <div class="pagination-controls">
            <button
              class="page-btn"
              :disabled="currentPage === 1"
              @click="currentPage--"
            >
              ◀
            </button>
            <div class="page-numbers">
              <button
                v-for="page in visiblePages"
                :key="page"
                class="page-number"
                :class="{ active: currentPage === page }"
                @click="currentPage = page"
              >
                {{ page }}
              </button>
            </div>
            <button
              class="page-btn"
              :disabled="currentPage === totalPages"
              @click="currentPage++"
            >
              ▶
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>

    <!-- 中间区域 -->
    <div class="culture-center-panel">
      <!-- 活动详情 -->
      <div v-if="selectedActivity" class="card activity-detail">
        <div class="section-title">优秀活动风采</div>
        <div class="activity-detail-main">
          <div class="activity-detail-image">
            <img v-if="selectedActivity.image" :src="selectedActivity.image" :alt="selectedActivity.title" />
            <div v-else class="image-placeholder">🏓</div>
          </div>
          <div class="activity-detail-right">
            <div class="activity-detail-header">
              <div class="detail-title">{{ selectedActivity.title }}</div>
              <div class="activity-type-tag">{{ selectedActivity.type }}</div>
            </div>
            <div class="activity-detail-info">
              <div class="info-row">
                <span class="info-label">活动时间：</span>
                <span class="info-value">{{ selectedActivity.timeRange }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">活动地点：</span>
                <span class="info-value">{{ selectedActivity.location }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">活动人数：</span>
                <span class="info-value">{{ selectedActivity.participants }}人</span>
              </div>
              <div class="info-row info-row-multiline">
                <span class="info-label">活动说明：</span>
                <span class="info-value">{{ selectedActivity.description }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="info-divider"></div>
        <div class="activity-detail-text">
          {{ selectedActivity.detailText }}
        </div>
        <div class="activity-gallery">
          <div
            v-for="(img, idx) in selectedActivity.gallery"
            :key="idx"
            class="gallery-item"
            @click="viewImage(img)"
          >
            <img :src="img" :alt="`活动图片${idx + 1}`" />
          </div>
        </div>
      </div>

      <!-- 优秀活动列表 -->
      <div class="card excellent-activities">
        <div class="section-header">
          <div class="section-title">优秀活动列表</div>
          <button class="btn btn-sm" @click="showDetails">详情</button>
        </div>
        <div class="excellent-activities-scroll">
          <button
            class="scroll-btn scroll-left"
            :class="{ disabled: selectedExcellentIndex === 0 }"
            :disabled="selectedExcellentIndex === 0"
            @click.stop="switchExcellentActivity('prev')"
            type="button"
          >◀</button>
          <div ref="excellentScrollRef" class="excellent-list">
            <div
              v-for="(activity, idx) in excellentActivities"
              :key="activity.id"
              class="excellent-item"
              :class="{ active: selectedExcellentIndex === idx }"
              @click="selectExcellentActivity(activity, idx)"
            >
              <div class="excellent-thumbnail">
                <img v-if="activity.thumbnail" :src="activity.thumbnail" :alt="activity.title" />
                <div v-else class="thumbnail-placeholder">🏓</div>
              </div>
              <div class="excellent-title">{{ activity.title }}</div>
            </div>
          </div>
          <button
            class="scroll-btn scroll-right"
            :class="{ disabled: selectedExcellentIndex === excellentActivities.length - 1 }"
            :disabled="selectedExcellentIndex === excellentActivities.length - 1"
            @click.stop="switchExcellentActivity('next')"
            type="button"
          >▶</button>
        </div>
      </div>
    </div>

    <!-- 右侧面板 -->
    <div class="culture-right-panel-wrapper">
      <div class="culture-right-panel">
      <!-- 活动分类统计 -->
      <div class="card section-category-stats">
        <div class="section-header">
          <div class="section-title">活动分类统计</div>
          <button class="btn btn-sm" @click="showDetails">详情</button>
        </div>
        <div class="category-content-new">
          <div class="category-chart-wrapper">
            <div ref="categoryChartRef" class="chart-container"></div>
          </div>
          <div class="category-list-new">
            <div v-for="category in categories" :key="category.name" class="category-item-new">
              <div class="category-left">
                <span class="category-color" :style="{ backgroundColor: getCategoryColor(category.name) }"></span>
                <span class="category-name">{{ category.name }}</span>
              </div>
              <span class="category-count">{{ category.count }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 参与人年龄分布 -->
      <div class="card section-age-distribution">
        <div class="section-header">
          <div class="section-title">参与人年龄分布</div>
          <button class="btn btn-sm" @click="showDetails">详情</button>
        </div>
        <div class="age-content">
          <div class="age-legend">
            <div v-for="item in ageDistributionData" :key="item.name" class="age-legend-item">
              <span class="age-color" :style="{ backgroundColor: item.color }"></span>
              <span class="age-text">{{ item.name }} {{ item.value }}%</span>
            </div>
          </div>
          <div class="age-chart">
            <div ref="ageChartRef" class="chart-container"></div>
          </div>
        </div>
      </div>

      <!-- 活动参与率排行 -->
      <div class="card section-participation-ranking">
        <div class="section-header">
          <div class="section-title">活动参与率排行</div>
          <button class="btn btn-sm" @click="showDetails">详情</button>
        </div>
        <div class="ranking-chart">
          <div ref="participationChartRef" class="chart-container"></div>
        </div>
      </div>
      </div>
    </div>

    <!-- 图片预览模态框 -->
    <div v-if="imagePreviewVisible" class="image-modal" @click="closeImagePreview">
      <div class="image-modal-content" @click.stop>
        <button class="image-modal-close" @click="closeImagePreview">×</button>
        <img :src="previewImageUrl" alt="预览图片" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { communityStore } from '../stores/community'
import { getCommunityNames } from '../utils/communityConfig'

export default {
  name: 'CultureCenter',
  data() {
    return {
      communityStore,
      communityNames: getCommunityNames(),
      selectedCommunity: communityStore.currentCommunity,
      // 年龄分布数据
      ageDistributionData: [
        { name: '青年段: 18-25岁', value: '45.12', color: '#ff6b6b' },
        { name: '中年段: 41-65岁', value: '25.23', color: '#339af0' },
        { name: '儿童段: 0-6岁', value: '17.23', color: '#51cf66' },
        { name: '老年段: >65岁', value: '12.65', color: '#74c0fc' },
        { name: '少年段: 7-17岁', value: '8.36', color: '#ffc107' }
      ],
      // 图表实例
      activityStatusChart: null,
      categoryChart: null,
      ageChart: null,
      participationChart: null,
      // 分页
      currentPage: 1,
      pageSize: 6, // 每页显示6条
      // 选中的活动
      selectedActivity: null,
      selectedExcellentIndex: 0,
      // 图片预览
      imagePreviewVisible: false,
      previewImageUrl: '',
      // 活动数据
      activities: [
        {
          id: 1,
          title: '青云锦绣小区乒乓球比赛',
          location: '青云锦绣小区体育馆',
          dateRange: '2022/08/12-2022/08/15',
          status: '进行中',
          statusClass: 'in-progress',
          type: '体育活动',
          timeRange: '2021-8-29 12:20 - 2021-9-10 12:00',
          participants: 15,
          description: '这是活动说明这是活动说明这是活动说明这是活动说明 这是活动说明这是活动说明',
          detailText: '据国际乒联官网消息，WTT杜塞尔多夫站比赛将于2024年1月15日至21日举行，这是WTT系列赛的重要一站。本次比赛吸引了来自世界各地的优秀选手参加，包括多位世界排名前20的选手。比赛将分为男子单打、女子单打、男子双打、女子双打和混合双打五个项目。预计将有超过200名选手参与角逐，竞争将非常激烈。',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDA2NmNjIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7kuLDovb3lpKflrabnlJ/niYg8L3RleHQ+PC9zdmc+',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iIzAwNjZjYyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5Liw6L295aSn5a2m55Sf54mIPC90ZXh0Pjwvc3ZnPg==',
          gallery: [
            'https://picsum.photos/280/200?random=101',
            'https://picsum.photos/280/200?random=102',
            'https://picsum.photos/400/250?random=103',
            'https://picsum.photos/280/200?random=104',
            'https://picsum.photos/280/200?random=105',
            'https://picsum.photos/320/180?random=106'
          ]
        },
        {
          id: 2,
          title: '"书写未来"书法大赛',
          location: '社区文化活动中心',
          dateRange: '2022/08/10-2022/08/20',
          status: '未开始',
          statusClass: 'not-started',
          type: '文娱活动',
          timeRange: '2022-08-10 09:00 - 2022-08-20 17:00',
          participants: 30,
          description: '书法比赛活动说明',
          detailText: '书法比赛的详细说明...',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDBkNTRmZiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjI0IiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5Ye65piv5LqL5Lu2PC90ZXh0Pjwvc3ZnPg==',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iIzAwZDU0ZmYiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZm9udC1zaXplPSIxMCIgZmlsbD0iI2ZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuWHuuaYr+S6i+S7tjwvdGV4dD48L3N2Zz4=',
          gallery: []
        },
        {
          id: 3,
          title: '"不忘初心"大合唱',
          location: '社区广场',
          dateRange: '2022/07/20-2022/07/25',
          status: '已结束',
          statusClass: 'completed',
          type: '演艺活动',
          timeRange: '2022-07-20 19:00 - 2022-07-25 21:00',
          participants: 50,
          description: '大合唱活动说明',
          detailText: '大合唱活动的详细说明...',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmZjMTA3Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7lpKnkuIDovb3lpKflrabnlJ/niYgPC90ZXh0Pjwvc3ZnPg==',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2ZmYzEwNyIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5aSp5LiA6L295aSn5a2m55Sf54mIPC90ZXh0Pjwvc3ZnPg==',
          gallery: []
        },
        {
          id: 4,
          title: '关坡冲锋杯篮球赛',
          location: '社区篮球场',
          dateRange: '2022/09/01-2022/09/10',
          status: '进行中',
          statusClass: 'in-progress',
          type: '体育活动',
          timeRange: '2022-09-01 14:00 - 2022-09-10 18:00',
          participants: 24,
          description: '篮球比赛活动说明',
          detailText: '篮球比赛的详细说明...',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjNGNhZjUwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7npLrkvovlpKflrabnlJ/niYgPC90ZXh0Pjwvc3ZnPg==',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iIzRjYWY1MCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+56S65L6L5aSn5a2m55Sf54mIPC90ZXh0Pjwvc3ZnPg==',
          gallery: []
        },
        {
          id: 5,
          title: '"中国梦"绘画大赛',
          location: '社区艺术馆',
          dateRange: '2022/08/25-2022/09/05',
          status: '进行中',
          statusClass: 'in-progress',
          type: '文娱活动',
          timeRange: '2022-08-25 09:00 - 2022-09-05 17:00',
          participants: 45,
          description: '绘画比赛活动说明',
          detailText: '绘画比赛的详细说明...',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjOWMyN2IwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7lm73pmYXlpKflrabnlJ/niYgPC90ZXh0Pjwvc3ZnPg==',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iIzljMjdiMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5Zu96ZmF5aSn5a2m55Sf54mIPC90ZXh0Pjwvc3ZnPg==',
          gallery: []
        },
        {
          id: 6,
          title: '社区健康讲座',
          location: '社区活动中心',
          dateRange: '2022/09/15-2022/09/15',
          status: '未开始',
          statusClass: 'not-started',
          type: '科教活动',
          timeRange: '2022-09-15 14:00 - 2022-09-15 16:00',
          participants: 80,
          description: '健康讲座活动说明',
          detailText: '健康讲座的详细说明...',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY5ODAwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7lm73pmYXlpKflrabnlJ/niYgPC90ZXh0Pjwvc3ZnPg==',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2ZmOTgwMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5Zu96ZmF5aSn5a2m55Sf54mIPC90ZXh0Pjwvc3ZnPg==',
          gallery: []
        },
        {
          id: 7,
          title: '环保志愿活动',
          location: '社区公园',
          dateRange: '2022/09/20-2022/09/20',
          status: '未开始',
          statusClass: 'not-started',
          type: '志愿活动',
          timeRange: '2022-09-20 08:00 - 2022-09-20 12:00',
          participants: 60,
          description: '环保志愿活动说明',
          detailText: '环保志愿活动的详细说明...',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDBiY2Q0Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7npLrkvovlpKflrabnlJ/niYgPC90ZXh0Pjwvc3ZnPg==',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iIzAwYmNkNCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+56S65L6L5aSn5a2m55Sf54mIPC90ZXh0Pjwvc3ZnPg==',
          gallery: []
        },
        {
          id: 8,
          title: '党员学习会',
          location: '社区会议室',
          dateRange: '2022/09/18-2022/09/18',
          status: '未开始',
          statusClass: 'not-started',
          type: '党员活动',
          timeRange: '2022-09-18 15:00 - 2022-09-18 17:00',
          participants: 35,
          description: '党员学习会活动说明',
          detailText: '党员学习会的详细说明...',
          image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY1YTZhIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj7lpKnkuIDovb3lpKflrabnlJ/niYgPC90ZXh0Pjwvc3ZnPg==',
          thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2ZmNWE2YSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZmZmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5aSp5LiA6L295aSn5a2m55Sf54mIPC90ZXh0Pjwvc3ZnPg==',
          gallery: []
        },
        {
          id: 9,
          title: '社区广场舞比赛',
          location: '社区广场',
          dateRange: '2022/08/28-2022/08/30',
          status: '已结束',
          statusClass: 'completed',
          type: '演艺活动',
          timeRange: '2022-08-28 19:00 - 2022-08-30 21:00',
          participants: 120,
          description: '广场舞比赛活动说明',
          detailText: '广场舞比赛的详细说明...',
          image: 'https://picsum.photos/600/300?random=9',
          thumbnail: 'https://picsum.photos/80/60?random=9',
          gallery: []
        },
        {
          id: 10,
          title: '儿童趣味运动会',
          location: '社区运动场',
          dateRange: '2022/09/10-2022/09/12',
          status: '进行中',
          statusClass: 'in-progress',
          type: '体育活动',
          timeRange: '2022-09-10 09:00 - 2022-09-12 17:00',
          participants: 90,
          description: '儿童趣味运动会活动说明',
          detailText: '儿童趣味运动会的详细说明...',
          image: 'https://picsum.photos/600/300?random=10',
          thumbnail: 'https://picsum.photos/80/60?random=10',
          gallery: []
        },
        {
          id: 11,
          title: '中秋文艺晚会',
          location: '社区大礼堂',
          dateRange: '2022/09/08-2022/09/08',
          status: '已结束',
          statusClass: 'completed',
          type: '演艺活动',
          timeRange: '2022-09-08 19:30 - 2022-09-08 22:00',
          participants: 200,
          description: '中秋文艺晚会活动说明',
          detailText: '中秋文艺晚会的详细说明...',
          image: 'https://picsum.photos/600/300?random=11',
          thumbnail: 'https://picsum.photos/80/60?random=11',
          gallery: []
        },
        {
          id: 12,
          title: '社区读书会',
          location: '社区图书馆',
          dateRange: '2022/09/05-2022/09/25',
          status: '进行中',
          statusClass: 'in-progress',
          type: '文娱活动',
          timeRange: '2022-09-05 10:00 - 2022-09-25 16:00',
          participants: 40,
          description: '读书会活动说明',
          detailText: '读书会的详细说明...',
          image: 'https://picsum.photos/600/300?random=12',
          thumbnail: 'https://picsum.photos/80/60?random=12',
          gallery: []
        },
        {
          id: 13,
          title: '老年人健康体检',
          location: '社区医疗站',
          dateRange: '2022/09/12-2022/09/16',
          status: '进行中',
          statusClass: 'in-progress',
          type: '志愿活动',
          timeRange: '2022-09-12 08:00 - 2022-09-16 17:00',
          participants: 150,
          description: '健康体检活动说明',
          detailText: '健康体检的详细说明...',
          image: 'https://picsum.photos/600/300?random=13',
          thumbnail: 'https://picsum.photos/80/60?random=13',
          gallery: []
        },
        {
          id: 14,
          title: '社区象棋比赛',
          location: '社区活动室',
          dateRange: '2022/09/22-2022/09/25',
          status: '未开始',
          statusClass: 'not-started',
          type: '文娱活动',
          timeRange: '2022-09-22 14:00 - 2022-09-25 18:00',
          participants: 32,
          description: '象棋比赛活动说明',
          detailText: '象棋比赛的详细说明...',
          image: 'https://picsum.photos/600/300?random=14',
          thumbnail: 'https://picsum.photos/80/60?random=14',
          gallery: []
        },
        {
          id: 15,
          title: '社区安全知识讲座',
          location: '社区会议室',
          dateRange: '2022/09/19-2022/09/19',
          status: '未开始',
          statusClass: 'not-started',
          type: '科教活动',
          timeRange: '2022-09-19 15:00 - 2022-09-19 17:00',
          participants: 70,
          description: '安全知识讲座活动说明',
          detailText: '安全知识讲座的详细说明...',
          image: 'https://picsum.photos/600/300?random=15',
          thumbnail: 'https://picsum.photos/80/60?random=15',
          gallery: []
        },
        {
          id: 16,
          title: '社区园艺培训',
          location: '社区花园',
          dateRange: '2022/09/14-2022/09/21',
          status: '进行中',
          statusClass: 'in-progress',
          type: '文娱活动',
          timeRange: '2022-09-14 09:00 - 2022-09-21 17:00',
          participants: 25,
          description: '园艺培训活动说明',
          detailText: '园艺培训的详细说明...',
          image: 'https://picsum.photos/600/300?random=16',
          thumbnail: 'https://picsum.photos/80/60?random=16',
          gallery: []
        },
        {
          id: 17,
          title: '社区邻里节',
          location: '社区中心广场',
          dateRange: '2022/09/24-2022/09/26',
          status: '未开始',
          statusClass: 'not-started',
          type: '文娱活动',
          timeRange: '2022-09-24 10:00 - 2022-09-26 20:00',
          participants: 300,
          description: '邻里节活动说明',
          detailText: '邻里节的详细说明...',
          image: 'https://picsum.photos/600/300?random=17',
          thumbnail: 'https://picsum.photos/80/60?random=17',
          gallery: []
        },
        {
          id: 18,
          title: '社区太极拳班',
          location: '社区广场',
          dateRange: '2022/09/01-2022/09/30',
          status: '进行中',
          statusClass: 'in-progress',
          type: '体育活动',
          timeRange: '2022-09-01 07:00 - 2022-09-30 08:00',
          participants: 50,
          description: '太极拳班活动说明',
          detailText: '太极拳班的详细说明...',
          image: 'https://picsum.photos/600/300?random=18',
          thumbnail: 'https://picsum.photos/80/60?random=18',
          gallery: []
        },
        {
          id: 19,
          title: '社区摄影展',
          location: '社区文化中心',
          dateRange: '2022/08/20-2022/09/10',
          status: '已结束',
          statusClass: 'completed',
          type: '文娱活动',
          timeRange: '2022-08-20 09:00 - 2022-09-10 17:00',
          participants: 200,
          description: '摄影展活动说明',
          detailText: '摄影展的详细说明...',
          image: 'https://picsum.photos/600/300?random=19',
          thumbnail: 'https://picsum.photos/80/60?random=19',
          gallery: []
        },
        {
          id: 20,
          title: '社区手工制作课',
          location: '社区活动室',
          dateRange: '2022/09/16-2022/09/23',
          status: '进行中',
          statusClass: 'in-progress',
          type: '文娱活动',
          timeRange: '2022-09-16 14:00 - 2022-09-23 16:00',
          participants: 30,
          description: '手工制作课活动说明',
          detailText: '手工制作课的详细说明...',
          image: 'https://picsum.photos/600/300?random=20',
          thumbnail: 'https://picsum.photos/80/60?random=20',
          gallery: []
        },
        {
          id: 21,
          title: '社区消防演练',
          location: '社区空地',
          dateRange: '2022/09/17-2022/09/17',
          status: '未开始',
          statusClass: 'not-started',
          type: '科教活动',
          timeRange: '2022-09-17 10:00 - 2022-09-17 12:00',
          participants: 100,
          description: '消防演练活动说明',
          detailText: '消防演练的详细说明...',
          image: 'https://picsum.photos/600/300?random=21',
          thumbnail: 'https://picsum.photos/80/60?random=21',
          gallery: []
        },
        {
          id: 22,
          title: '社区美食节',
          location: '社区中心广场',
          dateRange: '2022/09/25-2022/09/27',
          status: '未开始',
          statusClass: 'not-started',
          type: '文娱活动',
          timeRange: '2022-09-25 11:00 - 2022-09-27 19:00',
          participants: 250,
          description: '美食节活动说明',
          detailText: '美食节的详细说明...',
          image: 'https://picsum.photos/600/300?random=22',
          thumbnail: 'https://picsum.photos/80/60?random=22',
          gallery: []
        },
        {
          id: 23,
          title: '社区英语角',
          location: '社区活动中心',
          dateRange: '2022/09/03-2022/09/30',
          status: '进行中',
          statusClass: 'in-progress',
          type: '科教活动',
          timeRange: '2022-09-03 19:00 - 2022-09-30 21:00',
          participants: 45,
          description: '英语角活动说明',
          detailText: '英语角的详细说明...',
          image: 'https://picsum.photos/600/300?random=23',
          thumbnail: 'https://picsum.photos/80/60?random=23',
          gallery: []
        },
        {
          id: 24,
          title: '社区环保宣传',
          location: '社区各区域',
          dateRange: '2022/09/11-2022/09/18',
          status: '进行中',
          statusClass: 'in-progress',
          type: '志愿活动',
          timeRange: '2022-09-11 09:00 - 2022-09-18 17:00',
          participants: 80,
          description: '环保宣传活动说明',
          detailText: '环保宣传的详细说明...',
          image: 'https://picsum.photos/600/300?random=24',
          thumbnail: 'https://picsum.photos/80/60?random=24',
          gallery: []
        },
        {
          id: 25,
          title: '社区棋牌比赛',
          location: '社区活动室',
          dateRange: '2022/09/26-2022/09/28',
          status: '未开始',
          statusClass: 'not-started',
          type: '文娱活动',
          timeRange: '2022-09-26 14:00 - 2022-09-28 18:00',
          participants: 60,
          description: '棋牌比赛活动说明',
          detailText: '棋牌比赛的详细说明...',
          image: 'https://picsum.photos/600/300?random=25',
          thumbnail: 'https://picsum.photos/80/60?random=25',
          gallery: []
        }
      ],
      // 优秀活动列表
      excellentActivities: [
        { id: 1, title: '第一届乒乓球比赛', thumbnail: 'https://picsum.photos/100/65?random=1' },
        { id: 2, title: '"书写未来"书法大赛', thumbnail: 'https://picsum.photos/100/65?random=2' },
        { id: 3, title: '"不忘初心"大合唱', thumbnail: 'https://picsum.photos/100/65?random=3' },
        { id: 4, title: '关坡冲锋杯篮球赛', thumbnail: 'https://picsum.photos/100/65?random=4' },
        { id: 5, title: '"中国梦"绘画大赛', thumbnail: 'https://picsum.photos/100/65?random=5' }
      ],
      // 分类数据
      categories: [
        { name: '文娱活动', count: 779 },
        { name: '体育活动', count: 779 },
        { name: '演艺活动', count: 779 },
        { name: '科教活动', count: 779 },
        { name: '志愿活动', count: 779 },
        { name: '党员活动', count: 779 },
        { name: '其他', count: 779 }
      ]
    }
  },
  computed: {
    totalActivities() {
      return this.activities.length
    },
    totalPages() {
      return Math.ceil(this.totalActivities / this.pageSize)
    },
    displayedActivities() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.activities.slice(start, end)
    },
    visiblePages() {
      const pages = []
      const maxVisible = 5
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2))
      let end = Math.min(this.totalPages, start + maxVisible - 1)
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1)
      }
      for (let i = start; i <= end; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  watch: {
    selectedCommunity(v) {
      if (v !== this.communityStore.currentCommunity) {
        this.communityStore.setCurrentCommunity(v)
      }
    },
    'communityStore.currentCommunity'(v) {
      this.selectedCommunity = v
    },
    activities: {
      handler() {
        if (this.activities.length > 0 && !this.selectedActivity) {
          this.selectedActivity = this.activities[0]
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.activityStatusChartRef) {
        this.initActivityStatusChart()
      }
      if (this.$refs.categoryChartRef) {
        this.initCategoryChart()
      }
      if (this.$refs.ageChartRef) {
        this.initAgeChart()
      }
      if (this.$refs.participationChartRef) {
        this.initParticipationChart()
      }
    })

    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.activityStatusChart) this.activityStatusChart.dispose()
    if (this.categoryChart) this.categoryChart.dispose()
    if (this.ageChart) this.ageChart.dispose()
    if (this.participationChart) this.participationChart.dispose()

    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 生成 SVG 占位图（不依赖外部网络）
    generatePlaceholderImage(width, height, text = '活动图片', color = '#0066cc') {
      const svg = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="${color}"/>
        <text x="50%" y="50%" font-size="${Math.min(width, height) / 8}" fill="#fff" text-anchor="middle" dy=".3em">${text}</text>
      </svg>`
      return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)))
    },
    // 选择活动
    selectActivity(activity) {
      this.selectedActivity = activity
    },
    // 选择优秀活动
    selectExcellentActivity(activity, index) {
      this.selectedExcellentIndex = index
      const fullActivity = this.activities.find(a => a.id === activity.id)
      if (fullActivity) {
        this.selectedActivity = fullActivity
      }
    },
    // 切换优秀活动（上一个/下一个）
    switchExcellentActivity(direction) {
      if (direction === 'prev') {
        // 切换到上一个活动
        if (this.selectedExcellentIndex > 0) {
          this.selectedExcellentIndex--
          const activity = this.excellentActivities[this.selectedExcellentIndex]
          this.selectExcellentActivity(activity, this.selectedExcellentIndex)
        }
      } else if (direction === 'next') {
        // 切换到下一个活动
        if (this.selectedExcellentIndex < this.excellentActivities.length - 1) {
          this.selectedExcellentIndex++
          const activity = this.excellentActivities[this.selectedExcellentIndex]
          this.selectExcellentActivity(activity, this.selectedExcellentIndex)
        }
      }

      // 滚动到选中的活动项（可选，让选中的项可见）
      this.$nextTick(() => {
        const scrollElement = this.$refs.excellentScrollRef
        if (scrollElement) {
          const selectedElement = scrollElement.children[this.selectedExcellentIndex]
          if (selectedElement) {
            selectedElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            })
          }
        }
      })
    },
    // 查看图片
    viewImage(url) {
      this.previewImageUrl = url
      this.imagePreviewVisible = true
    },
    // 关闭图片预览
    closeImagePreview() {
      this.imagePreviewVisible = false
    },
    // 获取分类颜色（与图表颜色对应）
    getCategoryColor(categoryName) {
      const colorMap = {
        '文娱活动': '#00d4ff',
        '体育活动': '#ff6b6b',
        '演艺活动': '#ffc107',
        '科教活动': '#51cf66',
        '志愿活动': '#339af0',
        '党员活动': '#845ef7',
        '其他': '#f783ac'
      }
      return colorMap[categoryName] || '#00d4ff'
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.activityStatusChart) this.activityStatusChart.resize()
      if (this.categoryChart) this.categoryChart.resize()
      if (this.ageChart) this.ageChart.resize()
      if (this.participationChart) this.participationChart.resize()
    },
    // 初始化活动状态统计图表
    initActivityStatusChart() {
      if (!this.$refs.activityStatusChartRef) return
      this.activityStatusChart = echarts.init(this.$refs.activityStatusChartRef)

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'center',
          textStyle: {
            color: '#a0b3c8',
            fontSize: 12
          },
          itemGap: 10
        },
        series: [
          {
            name: '外层',
            type: 'pie',
            radius: ['50%', '75%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: '#0a1929',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}\n{c}',
              fontSize: 11,
              color: '#a0b3c8'
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 8
            },
            data: [
              { value: 15, name: '已结束', itemStyle: { color: '#51cf66' } },
              { value: 12, name: '未开始', itemStyle: { color: '#a0b3c8' } }
            ]
          },
          {
            name: '内层',
            type: 'pie',
            radius: ['0%', '45%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: '#0a1929',
              borderWidth: 2
            },
            label: {
              show: false
            },
            data: [
              { value: 8, name: '进行中', itemStyle: { color: '#00d4ff' } }
            ]
          }
        ]
      }

      this.activityStatusChart.setOption(option)
    },
    // 初始化分类统计图表
    initCategoryChart() {
      if (!this.$refs.categoryChartRef) return
      this.categoryChart = echarts.init(this.$refs.categoryChartRef)

      const colors = ['#00d4ff', '#ff6b6b', '#ffc107', '#51cf66', '#339af0', '#845ef7', '#f783ac']

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
          backgroundColor: 'rgba(15, 30, 50, 0.95)',
          borderColor: '#00d4ff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          position: function (point, params, dom, rect, size) {
            // 智能计算tooltip位置，避免遮挡中心文字
            const chartWidth = size.viewSize[0]
            const chartHeight = size.viewSize[1]
            const tooltipWidth = size.contentSize[0] || 120
            const tooltipHeight = size.contentSize[1] || 40
            const x = point[0]
            const y = point[1]

            // 中心区域范围（避免tooltip出现在这里）
            const centerX = chartWidth / 2
            const centerY = chartHeight / 2
            const centerRadius = Math.min(chartWidth, chartHeight) * 0.25

            // 计算鼠标到中心的距离
            const distanceFromCenter = Math.sqrt(Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2))

            // 如果鼠标在中心区域，将tooltip显示在图表上方
            if (distanceFromCenter < centerRadius) {
              return [chartWidth / 2 - tooltipWidth / 2, 10]
            }

            // 否则显示在鼠标位置附近，但确保不超出图表边界
            let tooltipX = x - tooltipWidth / 2
            let tooltipY = y - tooltipHeight - 10

            // 边界检查
            if (tooltipX < 0) tooltipX = 10
            if (tooltipX + tooltipWidth > chartWidth) tooltipX = chartWidth - tooltipWidth - 10
            if (tooltipY < 0) tooltipY = y + 20 // 如果上方空间不够，显示在下方

            return [tooltipX, tooltipY]
          },
          confine: false,
          extraCssText: 'box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5); z-index: 1000;'
        },
        legend: {
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            roseType: false,
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 6,
              borderColor: '#0a1929',
              borderWidth: 2,
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 212, 255, 0.5)'
              },
              label: {
                fontSize: 14,
                fontWeight: 'bold',
                color: '#00d4ff'
              }
            },
            data: this.categories.map((cat, index) => ({
              value: cat.count,
              name: cat.name,
              itemStyle: {
                color: colors[index % 7]
              }
            }))
          },
          {
            type: 'pie',
            radius: ['0%', '35%'],
            center: ['50%', '50%'],
            itemStyle: {
              color: 'transparent'
            },
            label: {
              show: true,
              position: 'center',
              formatter: '{total|5548}\n\n{label|活动总数}',
              rich: {
                total: {
                  fontSize: 32,
                  fontWeight: 'bold',
                  color: '#00d4ff',
                  lineHeight: 40
                },
                label: {
                  fontSize: 14,
                  color: '#a0b3c8',
                  lineHeight: 20
                }
              }
            },
            data: [{ value: 1, name: '' }],
            silent: true
          }
        ]
      }

      this.categoryChart.setOption(option)
    },
    // 初始化年龄分布图表（漏斗图）
    initAgeChart() {
      if (!this.$refs.ageChartRef) return
      this.ageChart = echarts.init(this.$refs.ageChartRef)

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}%'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: '年龄分布',
            type: 'funnel',
            left: '5%',
            top: 20,
            bottom: 20,
            width: '50%',
            min: 0,
            max: 100,
            minSize: '0%',
            maxSize: '100%',
            sort: 'descending',
            gap: 3,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderColor: '#0a1929',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12
              }
            },
            data: [
              { value: 45.12, name: '青年段: 18-25岁', itemStyle: { color: '#ff6b6b' } },
              { value: 25.23, name: '中年段: 41-65岁', itemStyle: { color: '#339af0' } },
              { value: 17.23, name: '儿童段: 0-6岁', itemStyle: { color: '#51cf66' } },
              { value: 12.65, name: '老年段: >65岁', itemStyle: { color: '#74c0fc' } },
              { value: 8.36, name: '少年段: 7-17岁', itemStyle: { color: '#ffc107' } }
            ]
          }
        ]
      }

      this.ageChart.setOption(option)
    },
    // 初始化参与率排行图表
    initParticipationChart() {
      if (!this.$refs.participationChartRef) return
      this.participationChart = echarts.init(this.$refs.participationChartRef)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}: {c}%'
        },
        grid: {
          left: '12%',
          right: '15%',
          top: '18%',
          bottom: '12%',
          containLabel: false
        },
        xAxis: {
          type: 'category',
          data: ['文娱', '体育', '演艺', '科教', '志愿', '党员', '其他'],
          axisLabel: {
            color: '#fff',
            fontSize: 12
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 500,
          interval: 100,
          axisLabel: {
            color: '#a0b3c8',
            fontSize: 12
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
              type: 'solid',
              width: 1
            }
          }
        },
        graphic: [
          {
            type: 'text',
            left: '12%',
            top: '2%',
            style: {
              text: '单位: %',
              fill: '#a0b3c8',
              fontSize: 12,
              textAlign: 'left'
            }
          }
        ],
        legend: {
          show: true,
          right: '4%',
          top: '2%',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          data: ['活动参与率']
        },
        series: [
          {
            name: '活动参与率',
            type: 'bar',
            barWidth: '50%',
            data: [330, 290, 320, 370, 470, 420, 330],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: '#0066cc' },
                { offset: 1, color: '#00d4ff' }
              ]),
              borderRadius: [0, 0, 0, 0]
            },
            label: {
              show: false
            }
          }
        ]
      }

      this.participationChart.setOption(option)
    },
    showDetails() {
      // TODO: 弹窗显示详情
    }
  }
}
</script>

<style lang="scss" scoped>
.culture-center {
  display: grid;
  grid-template-columns: 400px 1fr 430px; // 与社区态势保持一致
  gap: 20px;
  height: 100%;
  overflow: hidden;
}

// 左侧面板
.culture-left-panel-wrapper {
  height: 100%;
  // border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  // padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden; // 外层容器隐藏溢出，内层处理滚动
  background: rgba(15, 30, 50, 0.6);
}

.culture-left-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1; // 占据剩余空间
  min-height: 0; // 重要：允许 flex 子元素缩小
  overflow-y: auto; // 内容超出时显示滚动条
  overflow-x: hidden;
  max-height: 100%; // 限制最大高度，确保可以滚动

  // 隐藏滚动条但保留滚动功能
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE/Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }

  ::v-deep .card {
    padding: 10px; // 与社区态势保持一致
  }

  ::v-deep .section-title {
    margin-bottom: 0; // 与社区态势保持一致
    font-size: 14px; // 与社区态势保持一致
  }

  // 所有卡片默认根据内容自适应
  .card {
    flex: 0 0 auto;
    min-height: 0; // 允许收缩
  }

  // 最后一个卡片占据剩余空间，并设置为 flex 容器
  .card:last-child {
    flex: 1 0 auto; // 占据剩余空间，但不收缩，允许根据内容增长
    display: flex;
    flex-direction: column;
    // 不设置 min-height，让内容自然增长
    // 不设置 overflow，让内容自然溢出，由父容器 .culture-left-panel 处理滚动
  }
}

.section-activity-stats {
  // flex 由 .card:last-child 控制（当它是最后一个时）
}

.activity-stats-content {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.stats-chart {
  height: 145px;
  .chart-container {
    width: 100%;
    height: 100%;
  }
}

.stats-metrics {
  display: flex;
  justify-content: space-around;
  padding: 11px 0;
  border-top: 1px solid rgba(0, 212, 255, 0.2);
}

.metric-item {
  text-align: center;
  .metric-value {
    font-size: 17px;
    font-weight: bold;
    color: #00d4ff;
    margin-bottom: 3px;
  }
  .metric-label {
    font-size: 11px;
    color: #a0b3c8;
  }
}

.section-activity-list {
  // flex 由 .card:last-child 控制（当它是最后一个时）
}

.activity-list-scroll {
  flex: 1;
  overflow: hidden; // 不允许出现滚动条
  padding-right: 2px;
  margin-bottom: 14px;
  min-height: 0; // 确保 flex 布局正常工作
}

.activity-list-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px;
  margin-bottom: 6px;
  background: rgba(15, 30, 50, 0.6);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(15, 30, 50, 0.8);
    border-color: rgba(0, 212, 255, 0.3);
  }

  &.active {
    background: rgba(0, 212, 255, 0.1);
    border-color: #00d4ff;
  }
}

.activity-thumbnail {
  width: 60px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(0, 212, 255, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .thumbnail-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
  }
}

.activity-info {
  flex: 1;
  min-width: 0;
  text-align: left;

  .activity-title {
    font-size: 13px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
    text-align: left;
  }

  .activity-meta {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 11px;
    color: #a0b3c8;
    line-height: 1.3;
    text-align: left;
    justify-content: flex-start;

    .activity-location,
    .activity-date {
      margin: 0;
    }
  }
}

.activity-status {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  white-space: nowrap;
  flex-shrink: 0;

  &.in-progress {
    background: transparent;
    color: #51cf66;
  }

  &.not-started {
    background: transparent;
    color: #ffa726;
  }

  &.completed {
    background: transparent;
    color: #00d4ff;
  }
}

.activity-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 15px;
  border-top: 1px solid rgba(0, 212, 255, 0.2);

  .page-info {
    font-size: 12px;
    color: #fff;
    white-space: nowrap;
  }

  .pagination-controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .page-numbers {
    display: flex;
    gap: 5px;
  }

  .page-btn {
    padding: 4px 8px;
    background: transparent;
    border: none;
    border-radius: 4px;
    color: #a0b3c8;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      color: #00d4ff;
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  .page-number {
    min-width: 28px;
    height: 28px;
    padding: 0 8px;
    background: rgba(15, 30, 50, 0.8);
    border: 1px solid rgba(0, 212, 255, 0.2);
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      border-color: rgba(0, 212, 255, 0.4);
    }

    &.active {
      background: #00d4ff;
      border-color: #00d4ff;
      color: #fff;
    }
  }
}

// 中间区域
.culture-center-panel {
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: hidden;
}

.activity-detail {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .section-title {
    font-size: 14px;
    margin-bottom: 12px;
  }
}

.activity-detail-right {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.activity-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0;
  margin-bottom: 12px;
  flex-shrink: 0;

  .detail-title {
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }

  .activity-type-tag {
    padding: 5px 14px;
    background: rgba(0, 212, 255, 0.2);
    border: 1px solid #00d4ff;
    border-radius: 20px;
    color: #00d4ff;
    font-size: 11px;
    font-weight: bold;
  }
}

.activity-detail-main {
  display: flex;
  gap: 25px;
  flex-shrink: 0;
  align-items: center;
}

.activity-detail-image {
  flex: 0 0 auto;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(0, 212, 255, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
  }
}

.activity-detail-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .info-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 13px;

    .info-label {
      color: #51cf66;
      min-width: 80px;
      font-weight: 500;
    }

    .info-value {
      color: #fff;
      flex: 1;
    }

    &.info-row-multiline {
      .info-value {
        white-space: normal;
        line-height: 1.6;
      }
    }
  }
}

.info-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 12px 0;
  width: 100%;
  flex-shrink: 0;
}

.activity-detail-text {
  margin-bottom: 12px;
  font-size: 13px;
  color: #fff;
  line-height: 1.6;
  text-align: left;
  flex-shrink: 0;
}

.activity-gallery {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(4, 65px);
  gap: 6px;
  position: relative;
  flex-shrink: 0;

  .gallery-item {
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    background: rgba(0, 212, 255, 0.1);
    transition: transform 0.3s ease, z-index 0.3s ease;
    position: relative;

    &:hover {
      transform: scale(1.05);
      z-index: 10;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    // 左侧两张垂直堆叠
    &:nth-child(1) {
      grid-column: 1 / 4;
      grid-row: 1 / 3;
    }

    &:nth-child(2) {
      grid-column: 1 / 4;
      grid-row: 3 / 5;
    }

    // 中间大图
    &:nth-child(3) {
      grid-column: 4 / 9;
      grid-row: 2 / 4;
      z-index: 2;
    }

    // 右侧两张垂直堆叠
    &:nth-child(4) {
      grid-column: 9 / 13;
      grid-row: 1 / 3;
    }

    &:nth-child(5) {
      grid-column: 9 / 13;
      grid-row: 3 / 5;
    }

    // 重叠的小图
    &:nth-child(6) {
      grid-column: 7 / 10;
      grid-row: 3 / 5;
      z-index: 3;
      transform: scale(0.85);

      &:hover {
        transform: scale(0.9);
      }
    }
  }
}

.excellent-activities {
  flex: 0 0 auto;

  .section-header {
    margin-bottom: 12px;
  }

  .section-title {
    font-size: 14px;
    margin-bottom: 0;
  }
}

.excellent-activities-scroll {
  position: relative;
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;

  // 确保按钮在最上层
  .scroll-btn {
    position: relative;
    z-index: 100;
  }
}

.scroll-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 50%;
  color: #00d4ff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: auto;
  z-index: 10;
  position: relative;

  &:hover:not(:disabled):not(.disabled) {
    background: rgba(0, 212, 255, 0.2);
    border-color: #00d4ff;
  }

  &:active:not(:disabled):not(.disabled) {
    background: rgba(0, 212, 255, 0.3);
  }

  &:disabled,
  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.excellent-list {
  flex: 1;
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  padding: 8px 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 212, 255, 0.3) transparent;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 212, 255, 0.3);
    border-radius: 2px;
  }
}

.excellent-item {
  flex-shrink: 0;
  width: 100px;
  cursor: pointer;
  transition: all 0.3s ease;

  .excellent-thumbnail {
    width: 100px;
    height: 65px;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(0, 212, 255, 0.1);
    margin-bottom: 6px;
    border: 2px solid transparent;
    transition: all 0.3s ease;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .thumbnail-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
    }
  }

  .excellent-title {
    font-size: 11px;
    color: #a0b3c8;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.active {
    .excellent-thumbnail {
      border-color: #00d4ff;
      box-shadow: 0 0 15px rgba(0, 212, 255, 0.5);
    }

    .excellent-title {
      color: #00d4ff;
      font-weight: bold;
    }
  }
}

// 右侧面板
.culture-right-panel-wrapper {
  height: 100%;
  // border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  // padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden; // 外层容器隐藏溢出，内层处理滚动
  background: rgba(15, 30, 50, 0.6);
}

.culture-right-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1; // 占据剩余空间
  min-height: 0; // 重要：允许 flex 子元素缩小
  overflow-y: auto; // 内容超出时显示滚动条
  overflow-x: hidden;
  max-height: 100%; // 限制最大高度，确保可以滚动

  // 隐藏滚动条但保留滚动功能
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE/Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }

  ::v-deep .card {
    padding: 10px; // 与社区态势保持一致
  }

  ::v-deep .section-title {
    margin-bottom: 0; // 与社区态势保持一致
    font-size: 14px; // 与社区态势保持一致
  }

  // 所有卡片默认根据内容自适应
  .card {
    flex: 0 0 auto;
    min-height: 0; // 允许收缩
  }

  // 最后一个卡片占据剩余空间，并设置为 flex 容器
  .card:last-child {
    flex: 1 0 auto; // 占据剩余空间，但不收缩，允许根据内容增长
    display: flex;
    flex-direction: column;
    // 不设置 min-height，让内容自然增长
    // 不设置 overflow，让内容自然溢出，由父容器 .culture-right-panel 处理滚动
  }
}

.section-category-stats {
  // flex 由 .card:last-child 控制（当它是最后一个时）
}

.category-content-new {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}

.category-chart-wrapper {
  flex: 0 0 50%;
  height: 160px;

  .chart-container {
    width: 100%;
    height: 100%;
  }
}

.category-list-new {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-item-new {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;

  .category-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .category-color {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .category-name {
    color: #a0b3c8;
    font-size: 13px;
    white-space: nowrap;
  }

  .category-count {
    color: #a0b3c8;
    font-size: 13px;
    flex-shrink: 0;
  }
}

.section-age-distribution {
  // flex 由 .card:last-child 控制（当它是最后一个时）

  .section-header {
    flex-shrink: 0;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .section-title {
    flex-shrink: 0;
    margin-bottom: 0;
    font-size: 14px;
  }
}

.age-content {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}

.age-legend {
  flex: 0 0 45%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.age-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;

  .age-color {
    width: 9px;
    height: 9px;
    border-radius: 2px;
    flex-shrink: 0;
  }

  .age-text {
    color: #a0b3c8;
    font-size: 12px;
  }
}

.age-chart {
  flex: 1;

  .chart-container {
    width: 100%;
    height: 180px;
  }
}

.section-participation-ranking {
  flex: 1; // 占据剩余空间，自动占满
  min-height: 220px; // 保留最小高度，确保图表能显示
  display: flex;
  flex-direction: column;
  overflow: hidden; // 防止内容溢出

  .section-header {
    flex-shrink: 0;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .section-title {
    flex-shrink: 0;
    margin-bottom: 0;
    font-size: 14px;
  }
}

.ranking-chart {
  flex: 1;
  min-height: 180px;

  .chart-container {
    width: 100%;
    height: 100%;
    min-height: 180px;
  }
}

// 图片预览模态框
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;

  .image-modal-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;

    img {
      max-width: 100%;
      max-height: 100%;
      border-radius: 8px;
    }
  }

  .image-modal-close {
    position: absolute;
    top: -40px;
    right: 0;
    width: 30px;
    height: 30px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

// 通用样式
.card {
  background: rgba(15, 30, 50, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  padding: 10px;
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.section-title {
  font-size: 14px;
  margin-bottom: 0;
}
</style>
